import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/frequently-asked-questions/PageContent.tsx");
